module.exports = __webpack_public_path__ + "img/icon_my_female_2.ee97ccdc.png";